import * as actions from './actions'
import { unlockPrivateKeySuccess } from '../crypto/actions'
import { call, put, takeEvery, select } from 'redux-saga/effects'
import * as openpgp from 'openpgp'

function* onNoteAdded({ payload: { key, note } }) {
  const { privKey, keyPassword } = yield select(state => ({
    privKey: state.crypto.keys.private,
    keyPassword: state.crypto.keyPassword
  }))
  if (keyPassword) {
    const { [key]: decryptedNote } = yield call(
      decryptNotesWithKey,
      { [key]: note },
      privKey,
      keyPassword
    )
    yield put(actions.addNote({ key, note, decryptedNote }))
  } else {
    yield put(actions.addNote({ key, note }))
  }
}

function* onNoteDeleted({ payload: { key } }) {
  yield put(actions.deleteNote(key))
}

async function decryptContentWithKey(content, key) {
  try {
    const decryptedMessage = await openpgp.decrypt({
      message: openpgp.message.readArmored(content),
      privateKey: key
    })
    return decryptedMessage.data
  } catch (err) {
    console.error(err)
    throw err
  }
}

async function decryptNote(note, privKey, keyPassword) {
  const key = openpgp.key.readArmored(privKey).keys[0]
  key.decrypt(keyPassword)
  return {
    title: await decryptContentWithKey(note.title, key),
    content: await decryptContentWithKey(note.content, key)
  }
}

async function decryptNotesWithDecryptor(encryptedNotes, privKey, keyPassword) {
  const keys = Object.keys(encryptedNotes)
  const decryptedNotes = {}
  for (const key of keys) {
    decryptedNotes[key] = await decryptNote(
      encryptedNotes[key],
      privKey,
      keyPassword
    )
  }
  return decryptedNotes
}

function* decryptNotes({ payload: keyPassword }) {
  try {
    const { encryptedNotes, privKey } = yield select(state => ({
      encryptedNotes: state.notes.encryptedNotes,
      privKey: state.crypto.keys.private
    }))
    const decryptedNotes = yield call(
      decryptNotesWithKey,
      encryptedNotes,
      privKey,
      keyPassword
    )
    yield put(actions.decryptNotesSuccess(decryptedNotes))
  } catch (err) {
    console.error(err)
    yield put(actions.decryptNotesError(err))
  }
}

function* decryptNotesWithKey(encryptedNotes, privKey, keyPassword) {
  const decryptedNotes = yield call(
    decryptNotesWithDecryptor,
    encryptedNotes,
    privKey,
    keyPassword
  )
  return decryptedNotes
}

export default function*() {
  yield takeEvery(actions.firebaseNoteAdded, onNoteAdded)
  yield takeEvery(actions.firebaseNoteUpdated, onNoteAdded)
  yield takeEvery(actions.firebaseNoteDeleted, onNoteDeleted)
  yield takeEvery(unlockPrivateKeySuccess, decryptNotes)
}



// WEBPACK FOOTER //
// ./src/services/notes/sagas.js